export class BonificoDTO {
	iban: string;
}